import { useState } from 'react';
import { mapJpgUrl } from './layerLoader';
import apiFetch from './apiFetch';

function formatDownloadName(id) {
  const match = id.match(/^Mw(\d+)_C(\d+)$/);
  if (!match) return `${id}_Map.jpg`;
  const mag = (parseInt(match[1], 10) / 100).toFixed(1);
  const scenario = parseInt(match[2], 10);
  return `M${mag}_Scenario${scenario}_Map.jpg`;
}

// Shared "download the reference map JPEG" behaviour so both the sidebar/
// drawer/sheet scenario list and the mobile bottom action bar can trigger
// the same download without duplicating the fetch/blob logic.
export function useDownloadMap(selectedId) {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  async function download() {
    if (!selectedId || downloading) return;
    setDownloading(true);
    setError(null);

    try {
      const url = mapJpgUrl(selectedId);
      const response = await apiFetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = formatDownloadName(selectedId);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(objectUrl), 150);
    } catch (err) {
      console.error('[Download] failed:', err);
      setError('Map file not available for this scenario');
      setTimeout(() => setError(null), 3000);
    } finally {
      setDownloading(false);
    }
  }

  return { downloading, error, download };
}
